// frontend\src\pages\DevTimerSetup\constants.js
export const AGITATION_TYPES = {
  STANDARD: "standard",
  ROTARY: "rotary",
  STAND: "stand",
};

export const processPresets = {
  bw: {
    name: "Чёрно-белый",
    stages: {
      preSoak: {
        enabled: false,
        minutes: 1,
        seconds: 0,
        agitationType: AGITATION_TYPES.STAND,
      },
      developer: {
        enabled: true,
        minutes: 8,
        seconds: 0,
        agitationType: AGITATION_TYPES.STANDARD,
        agitation: {
          interval: 60,
          duration: 10,
          firstMinute: 30,
          lastMinute: 15,
        },
      },
      stopBath: {
        enabled: true,
        minutes: 1,
        seconds: 0,
        agitationType: AGITATION_TYPES.ROTARY,
        agitation: {
          duration: 60,
        },
      },
      fixer: {
        enabled: true,
        minutes: 5,
        seconds: 0,
        agitationType: AGITATION_TYPES.STANDARD,
        agitation: {
          interval: 60,
          duration: 5,
          firstMinute: 30,
          lastMinute: 15,
        },
      },
      wash: {
        enabled: false,
        minutes: 5,
        seconds: 0,
        agitationType: AGITATION_TYPES.STANDARD,
        agitation: {
          interval: 60,
          duration: 10,
          firstMinute: 30,
          lastMinute: 15,
        },
      },
      hypoClear: {
        enabled: false,
        minutes: 2,
        seconds: 0,
        agitationType: AGITATION_TYPES.STANDARD,
        agitation: {
          interval: 60,
          duration: 10,
        },
      },
      finalWash: {
        enabled: true,
        minutes: 10,
        seconds: 0,
        agitationType: AGITATION_TYPES.STANDARD,
        agitation: {
          interval: 120,
          duration: 15,
          firstMinute: 60,
          lastMinute: 30,
        },
      },
      wettingAgent: {
        enabled: false,
        minutes: 1,
        seconds: 0,
        agitationType: AGITATION_TYPES.STAND,
      },
    },
  },
  bw_reversal: {
    name: "Ч/Б обращаемый",
    stages: {
      preSoak: {
        enabled: false,
        minutes: 1,
        seconds: 0,
        agitationType: AGITATION_TYPES.STAND,
      },
      developer: {
        enabled: true,
        minutes: 8,
        seconds: 0,
        agitationType: AGITATION_TYPES.STANDARD,
        agitation: {
          interval: 60,
          duration: 10,
          firstMinute: 30,
          lastMinute: 15,
        },
      },
      stopBath: {
        enabled: true,
        minutes: 1,
        seconds: 0,
        agitationType: AGITATION_TYPES.ROTARY,
        agitation: {
          duration: 60,
        },
      },
      fixer: {
        name: "Первый фиксаж",
        enabled: true,
        minutes: 3,
        seconds: 0,
        agitationType: AGITATION_TYPES.STANDARD,
        agitation: {
          interval: 60,
          duration: 5,
          firstMinute: 30,
          lastMinute: 15,
        },
      },
      washAfterFix: {
        enabled: true,
        minutes: 3,
        seconds: 0,
        agitationType: AGITATION_TYPES.STANDARD,
        agitation: {
          interval: 60,
          duration: 10,
        },
      },
      bleach: {
        enabled: true,
        minutes: 2,
        seconds: 0,
        agitationType: AGITATION_TYPES.ROTARY,
        agitation: {
          duration: 120,
        },
      },
      reexposure: {
        enabled: true,
        minutes: 0,
        seconds: 30,
        agitationType: AGITATION_TYPES.STAND,
      },
      redevelopment: {
        enabled: true,
        minutes: 3,
        seconds: 0,
        agitationType: AGITATION_TYPES.STANDARD,
        agitation: {
          interval: 60,
          duration: 10,
          firstMinute: 30,
          lastMinute: 15,
        },
      },
      secondFixer: {
        enabled: true,
        minutes: 3,
        seconds: 0,
        agitationType: AGITATION_TYPES.STANDARD,
        agitation: {
          interval: 60,
          duration: 5,
        },
      },
      hypoClear: {
        enabled: false,
        minutes: 2,
        seconds: 0,
        agitationType: AGITATION_TYPES.STANDARD,
        agitation: {
          interval: 60,
          duration: 10,
        },
      },
      finalWash: {
        enabled: true,
        minutes: 10,
        seconds: 0,
        agitationType: AGITATION_TYPES.STANDARD,
        agitation: {
          interval: 120,
          duration: 15,
          firstMinute: 60,
          lastMinute: 30,
        },
      },
      wettingAgent: {
        enabled: false,
        minutes: 1,
        seconds: 0,
        agitationType: AGITATION_TYPES.STAND,
      },
    },
  },
  e6: {
    name: "E-6 (Слайд)",
    stages: {
      firstDeveloper: {
        enabled: true,
        minutes: 6,
        seconds: 30,
        agitationType: AGITATION_TYPES.STANDARD,
        agitation: {
          interval: 30,
          duration: 5,
          firstMinute: 30,
          lastMinute: 15,
        },
      },
      wash: {
        enabled: true,
        minutes: 2,
        seconds: 0,
        agitationType: AGITATION_TYPES.STANDARD,
        agitation: {
          interval: 60,
          duration: 10,
        },
      },
      reversalBath: {
        enabled: true,
        minutes: 2,
        seconds: 0,
        agitationType: AGITATION_TYPES.STAND,
      },
      colorDeveloper: {
        enabled: true,
        minutes: 6,
        seconds: 0,
        agitationType: AGITATION_TYPES.STANDARD,
        agitation: {
          interval: 30,
          duration: 5,
          firstMinute: 30,
          lastMinute: 15,
        },
      },
      preBleach: {
        enabled: true,
        minutes: 2,
        seconds: 0,
        agitationType: AGITATION_TYPES.STAND,
      },
      bleach: {
        enabled: true,
        minutes: 6,
        seconds: 0,
        agitationType: AGITATION_TYPES.STANDARD,
        agitation: {
          interval: 30,
          duration: 5,
          firstMinute: 30,
          lastMinute: 15,
        },
      },
      fixer: {
        enabled: true,
        minutes: 4,
        seconds: 0,
        agitationType: AGITATION_TYPES.STANDARD,
        agitation: {
          interval: 30,
          duration: 5,
        },
      },
      finalWash: {
        enabled: true,
        minutes: 4,
        seconds: 0,
        agitationType: AGITATION_TYPES.STANDARD,
        agitation: {
          interval: 60,
          duration: 10,
        },
      },
      stabilizer: {
        enabled: true,
        minutes: 1,
        seconds: 0,
        agitationType: AGITATION_TYPES.STAND,
      },
      wettingAgent: {
        enabled: false,
        minutes: 1,
        seconds: 0,
        agitationType: AGITATION_TYPES.STAND,
      },
    },
  },
  c41: {
    name: "C-41 (Негатив)",
    stages: {
      developer: {
        enabled: true,
        minutes: 3,
        seconds: 15,
        agitationType: AGITATION_TYPES.ROTARY,
        agitation: {
          duration: 195,
        },
      },
      bleach: {
        enabled: true,
        minutes: 4,
        seconds: 30,
        agitationType: AGITATION_TYPES.STANDARD,
        agitation: {
          interval: 30,
          duration: 5,
        },
      },
      wash: {
        enabled: true,
        minutes: 3,
        seconds: 0,
        agitationType: AGITATION_TYPES.STANDARD,
        agitation: {
          interval: 60,
          duration: 10,
        },
      },
      fixer: {
        enabled: true,
        minutes: 4,
        seconds: 0,
        agitationType: AGITATION_TYPES.STANDARD,
        agitation: {
          interval: 30,
          duration: 5,
        },
      },
      finalWash: {
        enabled: true,
        minutes: 3,
        seconds: 0,
        agitationType: AGITATION_TYPES.STANDARD,
        agitation: {
          interval: 60,
          duration: 10,
        },
      },
      stabilizer: {
        enabled: true,
        minutes: 1,
        seconds: 0,
        agitationType: AGITATION_TYPES.STAND,
      },
      wettingAgent: {
        enabled: false,
        minutes: 1,
        seconds: 0,
        agitationType: AGITATION_TYPES.STAND,
      },
    },
  },
};

export const allStages = {
  preSoak: {
    name: "Предварительное замачивание",
    description: "Выравнивание температуры плёнки",
  },
  developer: {
    name: "Проявитель",
    description: "Основной этап проявки",
  },
  stopBath: {
    name: "Стоп-ванна",
    description: "Остановка проявления",
  },
  fixer: {
    name: "Фиксаж",
    description: "Закрепление изображения",
  },
  wash: {
    name: "Промывка после фиксажа",
    description: "Удаление остатков фиксажа",
  },
  washAfterFix: {
    name: "Промывка после фиксажа",
    description: "Подготовка к отбеливанию",
  },
  bleach: {
    name: "Отбеливание",
    description: "Для обращаемой проявки",
  },
  reexposure: {
    name: "Повторная экспозиция",
    description: "Для создания позитива",
  },
  redevelopment: {
    name: "Повторная проявка",
    description: "Для обращаемой проявки",
  },
  secondFixer: {
    name: "Второй фиксаж",
    description: "Фиксаж после повторной проявки",
  },
  firstDeveloper: {
    name: "Первый проявитель (E-6)",
    description: "Чёрно-белое проявление",
  },
  reversalBath: {
    name: "Реверсивная ванна (E-6)",
    description: "Подготовка к цветному проявлению",
  },
  colorDeveloper: {
    name: "Цветной проявитель (E-6)",
    description: "Цветное проявление",
  },
  preBleach: {
    name: "Предотбеливание (E-6)",
    description: "Подготовка к отбеливанию",
  },
  stabilizer: {
    name: "Стабилизатор",
    description: "Стабилизация цветов",
  },
  hypoClear: {
    name: "Очистка (Hypo Clear)",
    description: "Ускорение удаления фиксажа",
  },
  finalWash: {
    name: "Финальная промывка",
    description: "Тщательное удаление химикатов",
  },
  wettingAgent: {
    name: "Смачиватель",
    description: "Предотвращение разводов",
  },
};

export const defaultAgitation = {
  interval: 30,
  duration: 10,
  firstMinute: 30,
  lastMinute: 15,
};
